// Üç durumlu erişim seçici (Gizli / Görüntüle / Düzenle) — portal yetki v2 §8.1, R2-26.
// Satır başına <fieldset><legend> + native radio grubu (ProjectNew adım 2 kalıbı): TEK seçim,
// ok tuşlarıyla gezinme tarayıcıdan gelir; çoklu seçim `aria-pressed` kalıbı burada YANLIŞ.
// Kategori satırı ve gösterge istisnası satırı AYNI bileşeni kullanır. Tavan (danışman / rol)
// aşan seviye pasif + tek satır yardım. Etiketler shared KPI_CATEGORY_ACCESS_LABELS.

import { useId } from "react";
import { KPI_CATEGORY_ACCESS_LABELS, type KpiEffectiveClientAccess } from "@mahir/shared";

const LEVELS: readonly KpiEffectiveClientAccess[] = ["closed", "readonly", "open"];

export interface AccessCategoryRadiosProps {
  /** Radio grubu adı — sayfada tekil olmalı (`cat-<setId>-<metricId>`). */
  name: string;
  legend: string;
  /** Legend altında soluk ikincil metin (kategori yolu). */
  hint?: string | undefined;
  /** Girinti (kategori derinliği). */
  depth?: number | undefined;
  value: KpiEffectiveClientAccess;
  /** Seviye → pasif nedeni (yardım satırı olarak bir kez gösterilir). */
  disabledLevels?: Partial<Record<KpiEffectiveClientAccess, string>> | undefined;
  disabled?: boolean | undefined;
  /** Soluk gösterim (etkisiz istisna). */
  muted?: boolean | undefined;
  onChange: (level: KpiEffectiveClientAccess) => void;
}

export function AccessCategoryRadios(props: AccessCategoryRadiosProps): JSX.Element {
  const { name, legend, hint, depth = 0, value, disabledLevels, disabled, muted, onChange } = props;
  const helpId = useId();
  const reasons = [
    ...new Set(LEVELS.map((l) => disabledLevels?.[l]).filter((r): r is string => !!r)),
  ];
  return (
    <fieldset
      data-testid="access-category-radios"
      className="py-1"
      style={{
        border: "none",
        margin: 0,
        paddingLeft: depth * 14,
        minWidth: 0,
        opacity: muted ? 0.55 : 1,
      }}
      aria-describedby={reasons.length > 0 ? helpId : undefined}
    >
      <legend className="text-sm p-0" style={{ color: "var(--color-text)", fontWeight: 500 }}>
        {legend}
        {hint ? (
          <span className="ml-2 text-xs" style={{ color: "var(--color-text-3)", fontWeight: 400 }}>
            {hint}
          </span>
        ) : null}
      </legend>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
        {LEVELS.map((level) => (
          <label
            key={level}
            className="flex items-center gap-1.5 text-sm"
            style={{
              color: disabledLevels?.[level] ? "var(--color-text-3)" : "var(--color-text-2)",
            }}
          >
            <input
              type="radio"
              name={name}
              value={level}
              checked={value === level}
              disabled={disabled === true || disabledLevels?.[level] !== undefined}
              onChange={() => onChange(level)}
            />
            {KPI_CATEGORY_ACCESS_LABELS[level]}
          </label>
        ))}
      </div>
      {reasons.length > 0 ? (
        <p id={helpId} className="text-xs mt-0.5" style={{ color: "var(--color-text-3)" }}>
          {reasons.join(" · ")}
        </p>
      ) : null}
    </fieldset>
  );
}
